import { Id } from "@planzone/dto";

type RestrictedAreas =
  | "personalSynthesis"
  | "personalTimesheet"
  | "resources"
  | "costProfiles"
  | "projectTemplates"
  | "projectReportsTemplate"
  | "projectStatuses"
  | "secondaryCriteriaTemplate"
  | "portfolios"
  | "calendar"
  | "strategicAxes"
  | "exports"
  | "documents"
  | "logs"
  | "onlyOffice"
  | "capacity"
  | "workload"
  | "occupancy";

type AccessRestrictions = {
  [Key in RestrictedAreas]: Id[];
};

const accessRestrictions: AccessRestrictions = {
  personalSynthesis: ["pz_admin", "pz_under_admin", "pz_user", "pz_visitor"],
  personalTimesheet: ["pz_admin", "pz_under_admin", "pz_user", "pz_visitor"],
  resources: ["pz_admin"],
  costProfiles: ["pz_admin"],
  projectTemplates: ["pz_admin"],
  projectReportsTemplate: ["pz_admin"],
  projectStatuses: ["pz_admin"],
  secondaryCriteriaTemplate: ["pz_admin"],
  strategicAxes: ["pz_admin"],
  portfolios: ["pz_admin"],
  calendar: ["pz_admin", "pz_under_admin", "pz_user", "pz_visitor"],
  exports: ["pz_admin"],
  documents: ["pz_admin"],
  logs: ["pz_admin"],
  onlyOffice: ["pz_admin"],
  capacity: ["pz_admin", "pz_under_admin", "pz_user", "pz_visitor"],
  workload: ["pz_admin", "pz_under_admin", "pz_user", "pz_visitor"],
  occupancy: ["pz_admin", "pz_under_admin", "pz_user", "pz_visitor"],
};

export type { AccessRestrictions, RestrictedAreas };

export { accessRestrictions };
